// components/AlumniContactInformation/AlumniContactInformation.tsx

import Image from "next/image";
import styles from "./AlumniContactInformation.module.css";

interface Link {
  id: number;
  label: string;
  url: string | null;
}

interface DesktopImage {
  id: number;
  url: string;
  alternativeText: string;
}

interface ContactCard {
  id: number;
  desktop_img: DesktopImage;
  links: Link[];
}

interface ContactInformationData {
  id: number;
  title: string;
  general_contact_information_card: ContactCard[];
}

interface AlumniContactInformationProps {
  data: ContactInformationData;
}

const AlumniContactInformation: React.FC<AlumniContactInformationProps> = ({
  data,
}) => {
  return (
    <div className={styles.container} id="alumniContact">
      <h2 className={styles.heading}>{data.title}</h2>
      <div className={styles.cards}>
        {data.general_contact_information_card.map((item) => (
          <div key={item.id} className={styles.card}>
            <Image
              src={item.desktop_img.url}
              alt={item.desktop_img.alternativeText || "icon"}
              width={60}
              height={60}
              className={styles.icon}
            />
            <ul className={styles.linkList}>
              {item.links.map((link) => {
                // Handle different types of links
                let href = link.url;
                const target = "_blank";
                const rel = "noopener noreferrer";

                // If it's an email link that doesn't start with mailto:
                if (
                  link.label.includes("@") &&
                  href &&
                  !href.startsWith("mailto:")
                ) {
                  href = `mailto:${href.replace(/^"mailto:"|"$/g, "")}`;
                }

                // For social media links, we might need to add proper URLs
                // if (href === "LinkedIn") {
                //   href =
                //     "https://www.linkedin.com/school/regenesys-business-school/";
                // } else if (href === "Instagram") {
                //   href = "https://www.instagram.com/regenesysbusinessschool/";
                // } else if (href === "X") {
                //   href = "https://twitter.com/RegenesysBS";
                // }

                return (
                  <li key={link.id}>
                    {href ? (
                      <a href={href} target={target} rel={rel}>
                        {link.label}
                      </a>
                    ) : (
                      <span>{link.label}</span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AlumniContactInformation;
